import { getData, saveData } from "../helpers/recentlyViewed";

const MAX_PRODUCTS = 12;

let currentProductSaved = false;

class PdpRecentlyViewed extends HTMLElement {
  constructor() {
    super();
    this.data = getData();

    const currentProductData = JSON.parse(
      this.querySelector("[data-current-product-data]").innerHTML,
    );

    currentProductData.savedAt = Date.now();

    this._init = () => {
      if (this.data.length) {
        const contentWrapper = this.querySelector("[data-content-wrapper]");
        const carouselTemplate = this.querySelector(
          "[data-product-card-carousel]",
        ).cloneNode(true);
        const carousel = carouselTemplate.content.querySelector(
          ".product-carousel__items",
        );
        const productsToDisplay = this.data
          .filter(
            (item) => item.handle && item.handle !== currentProductData.handle,
          )
          .slice(0, MAX_PRODUCTS);

        if (productsToDisplay.length) {
          carousel.innerHTML = productsToDisplay
            .map((item) => item.productCardMarkup)
            .join("");

          contentWrapper.innerHTML = "";
          contentWrapper.append(carouselTemplate.content);

          this.style.display = null;
        }
      }
    };

    this._init();

    this._refresh = () => {
      this.data = getData();
      this._init();
    };

    this.data.unshift(currentProductData);

    this.data = this.data
      // Filter to remove duplicates
      .filter(
        ({ handle }, i, items) =>
          items.findIndex((item) => handle === item.handle) === i,
      )
      // Save 1 extra so we can still show max number even if current product is included
      .slice(0, MAX_PRODUCTS + 1);

    try {
      if (!currentProductSaved) {
        saveData(this.data);
        currentProductSaved = true;
      }
    } catch (error) {
      console.warn("Error saving recently viewed products", error);
    }
  }

  connectedCallback() {
    document.addEventListener("recently-viewed:refreshed", this._refresh);
  }

  disconnectedCallback() {
    document.removeEventListener("recently-viewed:refreshed", this._refresh);
  }
}

if (!customElements.get("pdp-recently-viewed")) {
  customElements.define("pdp-recently-viewed", PdpRecentlyViewed);
}
